import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider } from 'styled-components';
import '../../assets/css/bootstrap.css';
import GlobalStyle from '../../assets/css/mainStyle';
import '../../assets/fonts/cerebrisans/cerebrisans.css';
import CookieConsentMessage from '../../components/CookieConsentMessage';
import Transition from '../../components/Transition';
import ScrollToTop from '../../components/ui/ScrollToTop';
import WhatsappButton from '../../components/WhatsappButton';
import { theme } from '../../theme';

const REGEX_ENABLE_RECAPTCHA = /((ouvidoria)|(fale-conosco)|(trabalhe-conosco)|(bolsao)|(segunda-via-boleto)|(evento\/*)|(checkout\/*))/i;
const reCaptchaKey = process.env.GATSBY_RECAPTCHA_KEY;

const LayoutContent = ({ location, children, whatsappRawNumber }) => (
  <ThemeProvider theme={theme}>
    <Transition location={location}>
      <div className="wrapper">
        <GlobalStyle />
        {children}
        <WhatsappButton number={whatsappRawNumber} />
        <ScrollToTop />
        <Toaster position="bottom-center" reverseOrder={false} />
      </div>
      <CookieConsentMessage />
    </Transition>
  </ThemeProvider>
);

const Layout = ({ children, location }) => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          contact {
            whatsappRawNumber
          }
        }
      }
    }
  `);

  const {
    contact: { whatsappRawNumber },
  } = site.siteMetadata;

  return REGEX_ENABLE_RECAPTCHA.test(location.pathname) ? (
    <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey} language="pt-BR">
      <LayoutContent location={location} whatsappRawNumber={whatsappRawNumber}>
        {children}
      </LayoutContent>
    </GoogleReCaptchaProvider>
  ) : (
    <LayoutContent location={location} whatsappRawNumber={whatsappRawNumber}>
      {children}
    </LayoutContent>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object.isRequired,
};

LayoutContent.propTypes = {
  location: PropTypes.object.isRequired,
  whatsappRawNumber: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Layout;
